import { Box, styled } from "~/common/mui";
import type { ConfiguratorControlChange } from "../controls";
import { GenericSubstep } from "./GenericSubstep";
import { CarouselColumnsSubstep } from "./CarouselColumnsSubstep";
import { ConfigurationAttachmentSubstep } from "./ConfigurationAttachmentSubstep";
import type { ConfiguratorAttachmentController, ConfiguratorSubstepViewModel } from "./substepViewModel";

const SubstepRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "disabled",
})<{ disabled?: boolean }>(({ disabled, theme }) => ({
  width: "100%",
  opacity: disabled ? theme.palette.action.disabledOpacity : 1,
}));

export interface SubstepRendererProps {
  viewModel: ConfiguratorSubstepViewModel;
  onControlChange: (change: ConfiguratorControlChange) => void;
  attachmentController?: ConfiguratorAttachmentController;
}

export const SubstepRenderer = ({ viewModel, onControlChange, attachmentController }: SubstepRendererProps) => {
  return (
    <SubstepRoot disabled={viewModel.disabled} aria-disabled={viewModel.disabled ? true : undefined}>
      {viewModel.renderer === "configurationAttachment" ? (
        <ConfigurationAttachmentSubstep viewModel={viewModel} controller={attachmentController} />
      ) : viewModel.renderer === "generic" ? (
        <GenericSubstep viewModel={viewModel} onControlChange={onControlChange} />
      ) : (
        <CarouselColumnsSubstep viewModel={viewModel} onControlChange={onControlChange} />
      )}
    </SubstepRoot>
  );
};
